import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { requestProjectCellMetrics } from '_/api/extractionCells/extractionCellMetrics.api';
import { ICellMetrics } from '_/types/extractionCells/extractionCellMetrics.types';

export const PROJECT_CELL_METRICS_QUERY_KEY = (projectId: string): string[] => ['project', projectId, 'cellMetrics'];

const REFRESH_INTERVAL_MS = 15 * 1000;

/**
 * Hook to fetch current metrics for every cell routed to a project, polled for a live view.
 */
export const useProjectCellMetrics = (projectId?: string): UseQueryResult<ICellMetrics[]> => {
  return useQuery({
    queryKey: PROJECT_CELL_METRICS_QUERY_KEY(projectId || ''),
    queryFn: () => requestProjectCellMetrics(projectId!),
    enabled: !!projectId,
    refetchInterval: REFRESH_INTERVAL_MS,
  });
};
